import axios from 'axios';
import { useTranslation } from 'react-i18next';

import { IdentityProvider } from 'api/identityProvider/GetIndetityProviderGetAllV1';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';

interface IProps {
	identityProvider: IdentityProvider;
}

const ExternalLogin = (props: IProps) => {
	const { t } = useTranslation();

	const handleLogin = async () => {
		const redirectUrl = new URL('/oauth', window.location.origin);
		const id = props.identityProvider.id;
		const url = new URL(
			`${SERVICEBASEURL.USER}/IdentityProvider/${id}/LoginJSON`,
			window.location.origin
		);
		url.searchParams.set('RedirectUrl', redirectUrl.toString());

		// the url should produce a redirection 302 FOUND
		// there is a problem with that in development
		// because the npm proxy rejects that and returns 200 OK/304 NOT MODIFIED code
		// use /Login instead of /LoginJSON and redirect with window.location.href, axios is not needed
		// window.location.href = url.toString();

		const relativeUrl = url.pathname + url.search;
		axios
			.get(relativeUrl)
			.then((res) => (window.location.href = res.data.authorizationUrl))
			.catch(console.error);
	};

	const renderContent = () => {
		return (
			<div className="d-grid gap-2">
				<button className="btn btn-primary mb-2" onClick={handleLogin}>
					<RenderIf condition={props.identityProvider.iconSvgUrl != null}>
						<img
							src={props.identityProvider.iconSvgUrl ?? ''}
							style={{ width: '20px', height: '20px', marginRight: '8px' }}
						></img>
					</RenderIf>
					<>
						{t('user:BTN_LOGIN_WITH')} {props.identityProvider.name}
					</>
				</button>
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default ExternalLogin;
